import React, { useState, useEffect, useContext } from "react"
import { Link, NavLink, useNavigate } from 'react-router-dom';
import MonthPickerComponent from '../../Utils/MonthPickerComponent'
import { TableDownloadContext } from '../../Contexts/TableDownloadContext'
import moment from 'moment';
import line from "../../images/line.png"
import xls from "../../images/xls/png/Group 47.png"
import FileIcon from "../../images/file.png"
import FileIconBlur from "../../images/fileblur.png"
import ExcelPopup from "../ExcelPopup";
import '../MainMenu.css'
import { routeNames } from "../../routeSegments";

import SavedFilterContent from "../../Components/SavedFilter";
import SavedFilterICON from "../../Components/SavedFilter/SavedFilterICON";
import ExportPopup from "../../Components/ExportPopup";
import {vcadvisorProfileExportData ,vcadvisorexitExportData } from "../../Components/ExportPopup/ExportData";
import { exportAdvisorExcel } from "../../Config/config";
import Constants from "../../Constants";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { UserContext } from "../../Contexts/UserContext";
import { useLocation } from 'react-router-dom'
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { RiMailDownloadLine } from "react-icons/ri";
import { Tooltip } from "antd";
import DownloadTrigger from "../ExportPopup/DownloadTrigger";
/**
 * The MainMenu function is a React component that renders a menu with different tabs and options based
 * on the props passed to it.
 * @param props - The props parameter is an object that contains the properties passed to the MainMenu
 * component. These properties can be accessed using dot notation, such as props.menu or props.submenu.
 * @returns The MainMenu component is returning a JSX element.
 */
function MainMenu(props) {
  // console.log(props.subMenu, "menuprops");

  const titleMap = {
    "advisor": {
      "vc": "VC Legal Advisors VC Investments - Venture Intelligence",
      "exist-ma-vc": "VC Legal Advisors VC Exits - Venture Intelligence",
      "exist-ma-ma": "VC Legal Advisors Via M&A (VC) - Venture Intelligence",
      "exist-pm-pm": "VC Legal Advisors Via Public Market (VC) - Venture Intelligence"
    }
  };
  
  const defaultTitle = "VC Legal Advisors VC Investment - Venture Intelligence";
  
  document.title = titleMap[props.menu]?.[props.subMenu] || defaultTitle;
  
  // const [save, setSave] = useState(false)
  const {save, setSave,showMonthPicker ,refineSearchFilters,groupId, isMobile,setOpen,open,setIsMobile} = useContext(PeFilterContext);
  const {activeTabDeal,setActiveTabDeal,setCurrentPage, globalSearchResult} =useContext(TableDataContext);

  const { handleDownloadExcel } = useContext(TableDownloadContext)
  const [openTab, setOpenTab] = React.useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ]);
  const { isStudent,isTrialExport} = useContext(UserContext)

  /**
   * The function `savedList` toggles the value of the `save` variable.
   */
  const savedList = () => {
    setSave(!save)
  }

  /* The above code is using the useEffect hook in React to set the value of the "openTab" state
  variable to the value of the "active" prop passed to the component. It is also specifying that the
  effect should only run when the "openTab" state variable changes. */
  useEffect(() => {
    setOpenTab(props.active)
  }, [openTab])

  useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }    },[])
  /**
   * The function `download` calls the `handleDownloadExcel` function.
   */
  const download = () => {
    handleDownloadExcel()
  }

  const { pathname } = useLocation(); 
  const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

  const globalSearchCategory =
    props.type === "vc_investment"
      ? "investments_ids"
      : props.type === "vc_exit"
      ? "exits_ids"
      : "";

  console.log(globalSearchCategory, "globalSearchCategory");

  
  return (
    <div className="pt-0 pl-3 pr-4 lg:pr-4 md:pr-2">

      <div className="scrollbar  rounded">
        <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
         <div></div>
        
         <div className={"justify-between items-center px-2 py-2 space-x-4 "+(showMonthPicker!=0 ? 'md:flex':'flex')}>
                  <div></div>
              <div className={showMonthPicker!=0 ?"hidden md:flex space-x-3":"flex space-x-3"}> 
              
              {isTrialExport =='false'||  isStudent == 'true' ? <></>  : <>                       
                  <button >
                      <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                    {showPopup && (
                      <div>
                        <ExportPopup onClose={() => setShowPopup(false)}
                          module="advisors"
                          modules="advisor" 
                          module_type={props.primaryTypeMasterId===Constants.primaryMasterIds.vcId?"vc":"pe"}
                          fileName={props.exportFileName}
                          url={exportAdvisorExcel}
                          exportOptions={props.subMenu === "vc" ?  vcadvisorProfileExportData   : vcadvisorexitExportData} 
                          type={props.type}
                          advisor_type={props.advisor_type}
                        />
                      </div>
                      
                    )}
                  </button>  
                </>}
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default MainMenu